/**
 * Helper to explicitly create a new config object for an API request body
 */
export default existingConfig => ({
  // TODO: Add some null check validations
  active: existingConfig.active,
  aircards: existingConfig.aircards,
  airlineCode: existingConfig.airlineCode,
  model: existingConfig.model,
  nai: existingConfig.nai,
  subnetGroup: existingConfig.subnetGroup,
});
